import {
  Box,
  Button,
  Divider,
  MenuItem,
  Stack,
  Typography,
} from "@mui/material";
import React, { useEffect, useState } from "react";
import { APP_ICONS } from "../../assets";
import DynamicTable from "../../components/dynamicTable";
import SelectInput from "../../components/select";
import TextInput from "../../components/textInput";
import AppContainer from "./../../components/containers/AppContainer";
import { CSVLink } from "react-csv";
import Loader from "../../components/loader";

const tableHeader = [
  // "VENDOR #ID",
  "WITHDRAWAL BY",
  "DATE",
  "AMOUNT",
  "STATUS",
  // "ACTION",
];

const displayRows = [
  // "user_id",
  "history_user_data",
  "created_at",
  "withDrawn_amount",
  "withDrawn_status",
  // "actions",
];

const selectInputWith = {
  width: { xs: "100%", md: "150px" },
};

const headersForCsv = [
  { label: "VENDOR NAME", key: "vendorName" },
  { label: "VENDOR EMAIL", key: "vendorEmail" },
  { label: "TOTAL SALES", key: "orderAmount" },
  { label: "COMMISSION%", key: "commissionPercentage" },
  { label: "AMOUNT", key: "commissionAmount" },
];

const WithDrawalsRequest = ({ data, monthTotal }) => {
  // const [filter, setFilter] = useState("yearly");
  // const [filterByStatus, setFilterByStatus] = useState("All");
  const [filterData, setFilterData] = useState([]);
  const [searchValue, setSearchValue] = useState("");
  const [isLoading, setIsLoading] = useState(false);

  useEffect(() => {
    filterAllVendorHistory();
  }, [searchValue, data]);

  const filterAllVendorHistory = () => {
    if (!searchValue.trim()) {
      setFilterData(data);
      return;
    }
    setIsLoading(true);
    const filtered = data.filter(
      (vendor) =>
        vendor?.vendorDetails?.name
          ?.toLowerCase()
          ?.includes(searchValue.toLowerCase()) ||
        vendor?.vendorDetails?.email
          ?.toLowerCase()
          ?.includes(searchValue.toLowerCase())
    );
    setFilterData(filtered);
    setIsLoading(false);
  };

  return (
    <AppContainer>
      <Stack
        px={2.5}
        py={2}
        direction={"row"}
        alignItems={"center"}
        justifyContent={"space-between"}
      >
        <Stack>
          <Typography variant="h5" fontWeight={600}>
            Withdrawal Requests
          </Typography>
          <Typography fontSize={"1.125rem"} color={"customColor.dustyGray"}>
            Total {monthTotal} Transaction Done In (MONTH)
          </Typography>
        </Stack>
        <CSVLink
          data={data}
          headers={headersForCsv}
          filename="filtered-users.csv"
          target="_blank"
          style={{ textDecoration: "none" }}
        >
          <Box
            height={40}
            bgcolor={"#003B95"}
            borderRadius={2}
            sx={{ width: { xs: "100%", md: 120 } }}
          >
            <Button>
              <Typography color="#FFF">Export</Typography>
            </Button>
          </Box>
        </CSVLink>
        {/* <SelectInput
          formStyleProps={{ width: { xs: "100%", sm: 150 } }}
          value={filter}
          onChange={(e) => setFilter(e.target.value)}
        >
          <MenuItem value={"yearly"}>Yearly </MenuItem>
          <MenuItem value={"monthly"}>Month </MenuItem>
        </SelectInput> */}
      </Stack>
      <Divider sx={{ borderColor: "#BDBDBD" }} />
      <Stack
        px={3}
        py={2}
        gap={2}
        direction={{ md: "row" }}
        alignItems={"center"}
      >
        <TextInput
          sx={{ flex: 1 }}
          placeholder={"Search Vendors"}
          InputStartIcon={<img src={APP_ICONS.searhIcon} width={20} />}
          value={searchValue}
          onChange={(e) => setSearchValue(e.target.value)}
        />
        <Stack
          direction={{ sm: "row" }}
          width={"100%"}
          flex={2}
          gap={2}
          justifyContent={{ md: "flex-end" }}
        >
          {/* <SelectInput
            placeholder={"Sort by status"}
            formStyleProps={selectInputWith}
            value={filterByStatus}
            onChange={(e) => setFilterByStatus(e.target.value)}
          >
            <MenuItem value={"All"}>All</MenuItem>
            <MenuItem value={"Active"}>Approved</MenuItem>
            <MenuItem value={"InActive"}>Pending</MenuItem>
            <MenuItem value={"Rejected"}>Rejected</MenuItem>
          </SelectInput> */}
        </Stack>
      </Stack>
      <Divider />
      {filterData?.length > 0 ? (
        <DynamicTable
          tableHeader={tableHeader}
          displayRows={displayRows}
          tableData={filterData}
          showPagination={true}
          showWithDrawnMenu={true}
        />
      ) : (
        <Typography
          color="black"
          fontSize={14}
          fontWeight={700}
          textAlign="center"
          padding="30px 0"
        >
          No History Found!
        </Typography>
      )}
      <Loader isloading={isLoading} />
    </AppContainer>
  );
};

export default WithDrawalsRequest;
